import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";
import { oneOfOptions, optionSchema } from "./choiceCommon.js";

const configSchema = z.object({
  options: z.array(optionSchema).default([]),
  placeholder: z.string().max(100).optional(),
  // A reference list is necessarily incomplete or goes stale — an LGA split off after this form was
  // built, a course of study nobody anticipated. Off by default: most dropdowns (yes/no-shaped
  // choices, a fixed enum a report groups by) are deliberately closed sets, and "Other" would just
  // undermine that. An author turns it on for a field that names something the real world adds to.
  allowOther: z.boolean().default(false),
});

export const dropdownField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "dropdown",
  label: "Dropdown",
  category: "choice",
  icon: "ChevronDown",
  configSchema,
  valueSchema: (config, isRequired) =>
    optionalUnlessRequired(oneOfOptions(config.options, config.allowOther), isRequired),
  defaultConfig: { options: [], allowOther: false },
  supportsProfileBinding: true,
  defaultSearchable: true,
  renderHints: {},
};
